"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingDetailsDtoCampaignEnum = exports.ListingDetailsDtoAuctionStatusEnum = exports.ListingDetailsDtoListingStatusEnum = exports.ListingDetailsDtoListingTypeEnum = exports.ListingDetailsDtoPropertyCategoryEnum = void 0;
exports.instanceOfListingDetailsDto = instanceOfListingDetailsDto;
exports.ListingDetailsDtoFromJSON = ListingDetailsDtoFromJSON;
exports.ListingDetailsDtoFromJSONTyped = ListingDetailsDtoFromJSONTyped;
exports.ListingDetailsDtoToJSON = ListingDetailsDtoToJSON;
exports.ListingDetailsDtoToJSONTyped = ListingDetailsDtoToJSONTyped;
var LovableExtrasDto_1 = require("./LovableExtrasDto");
var ListingDetailsSaleHistoryDto_1 = require("./ListingDetailsSaleHistoryDto");
var PropertyAmenityDto_1 = require("./PropertyAmenityDto");
var PropertyMediaItemDto_1 = require("./PropertyMediaItemDto");
var BidDto_1 = require("./BidDto");
var PropertyAttributesDto_1 = require("./PropertyAttributesDto");
var PropertyDocumentDto_1 = require("./PropertyDocumentDto");
var PriceEstimateDto_1 = require("./PriceEstimateDto");
var OpenInspectionDto_1 = require("./OpenInspectionDto");
var LocationDto_1 = require("./LocationDto");
var ListingDetailsUserDto_1 = require("./ListingDetailsUserDto");
/**
 * @export
 */
exports.ListingDetailsDtoPropertyCategoryEnum = {
    Residential: 'residential',
    Commercial: 'commercial',
    Business: 'business',
    Rural: 'rural',
    Land: 'land'
};
/**
 * @export
 */
exports.ListingDetailsDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.ListingDetailsDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * @export
 */
exports.ListingDetailsDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * @export
 */
exports.ListingDetailsDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * Check if a given object implements the ListingDetailsDto interface.
 */
function instanceOfListingDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isValuationListing' in value) || value['isValuationListing'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('propertyCategory' in value) || value['propertyCategory'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('allowPrivateInspection' in value) || value['allowPrivateInspection'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('displayPrice' in value) || value['displayPrice'] === undefined)
        return false;
    if (!('propertyAttributes' in value) || value['propertyAttributes'] === undefined)
        return false;
    if (!('propertyAmenities' in value) || value['propertyAmenities'] === undefined)
        return false;
    if (!('propertyMedia' in value) || value['propertyMedia'] === undefined)
        return false;
    if (!('propertyDocuments' in value) || value['propertyDocuments'] === undefined)
        return false;
    if (!('location' in value) || value['location'] === undefined)
        return false;
    if (!('isSeller' in value) || value['isSeller'] === undefined)
        return false;
    if (!('offersAllowed' in value) || value['offersAllowed'] === undefined)
        return false;
    if (!('enableAutoReply' in value) || value['enableAutoReply'] === undefined)
        return false;
    return true;
}
function ListingDetailsDtoFromJSON(json) {
    return ListingDetailsDtoFromJSONTyped(json, false);
}
function ListingDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'isValuationListing': json['isValuationListing'],
        'priceEstimate': json['priceEstimate'] == null ? undefined : (0, PriceEstimateDto_1.PriceEstimateDtoFromJSON)(json['priceEstimate']),
        'valuationRequestedAt': json['valuationRequestedAt'] == null ? undefined : (new Date(json['valuationRequestedAt'])),
        'slug': json['slug'],
        'propertyId': json['propertyId'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'propertyCategory': json['propertyCategory'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
        'listingType': json['listingType'],
        'listingStatus': json['listingStatus'],
        'auctionStatus': json['auctionStatus'] == null ? undefined : json['auctionStatus'],
        'auctionStartDate': json['auctionStartDate'] == null ? undefined : json['auctionStartDate'],
        'publishedAt': json['publishedAt'] == null ? undefined : json['publishedAt'],
        'allowPrivateInspection': json['allowPrivateInspection'],
        'price': json['price'],
        'displayPrice': json['displayPrice'],
        'priceText': json['priceText'] == null ? undefined : json['priceText'],
        'campaign': json['campaign'] == null ? undefined : json['campaign'],
        'auctionStartPrice': json['auctionStartPrice'] == null ? undefined : json['auctionStartPrice'],
        'auctionNextPriceDropAt': json['auctionNextPriceDropAt'] == null ? undefined : json['auctionNextPriceDropAt'],
        'auctionScheduledEndAt': json['auctionScheduledEndAt'] == null ? undefined : json['auctionScheduledEndAt'],
        'reverseAuctionDecreaseAmount': json['reverseAuctionDecreaseAmount'] == null ? undefined : json['reverseAuctionDecreaseAmount'],
        'propertyAttributes': (0, PropertyAttributesDto_1.PropertyAttributesDtoFromJSON)(json['propertyAttributes']),
        'propertyAmenities': (json['propertyAmenities'].map(PropertyAmenityDto_1.PropertyAmenityDtoFromJSON)),
        'openInspections': json['openInspections'] == null ? undefined : (json['openInspections'].map(OpenInspectionDto_1.OpenInspectionDtoFromJSON)),
        'activeOfferCount': json['activeOfferCount'] == null ? undefined : json['activeOfferCount'],
        'activeBidCount': json['activeBidCount'] == null ? undefined : json['activeBidCount'],
        'enquiryCount': json['enquiryCount'] == null ? undefined : json['enquiryCount'],
        'inspectionCount': json['inspectionCount'] == null ? undefined : json['inspectionCount'],
        'highestBid': json['highestBid'] == null ? undefined : (0, BidDto_1.BidDtoFromJSON)(json['highestBid']),
        'winningBid': json['winningBid'] == null ? undefined : (0, BidDto_1.BidDtoFromJSON)(json['winningBid']),
        'saleHistory': json['saleHistory'] == null ? undefined : (0, ListingDetailsSaleHistoryDto_1.ListingDetailsSaleHistoryDtoFromJSON)(json['saleHistory']),
        'propertyOwners': json['propertyOwners'] == null ? undefined : (json['propertyOwners'].map(ListingDetailsUserDto_1.ListingDetailsUserDtoFromJSON)),
        'propertyAgents': json['propertyAgents'] == null ? undefined : (json['propertyAgents'].map(ListingDetailsUserDto_1.ListingDetailsUserDtoFromJSON)),
        'propertyMedia': (json['propertyMedia'].map(PropertyMediaItemDto_1.PropertyMediaItemDtoFromJSON)),
        'propertyDocuments': (json['propertyDocuments'].map(PropertyDocumentDto_1.PropertyDocumentDtoFromJSON)),
        'location': (0, LocationDto_1.LocationDtoFromJSON)(json['location']),
        'isSeller': json['isSeller'],
        'offersAllowed': json['offersAllowed'],
        'enableAutoReply': json['enableAutoReply'],
        'lovableExtras': json['lovableExtras'] == null ? undefined : (0, LovableExtrasDto_1.LovableExtrasDtoFromJSON)(json['lovableExtras']),
        'lovableExtrasAddedOn': json['lovableExtrasAddedOn'] == null ? undefined : json['lovableExtrasAddedOn'],
    };
}
function ListingDetailsDtoToJSON(json) {
    return ListingDetailsDtoToJSONTyped(json, false);
}
function ListingDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'isValuationListing': value['isValuationListing'],
        'priceEstimate': (0, PriceEstimateDto_1.PriceEstimateDtoToJSON)(value['priceEstimate']),
        'valuationRequestedAt': value['valuationRequestedAt'] == null ? value['valuationRequestedAt'] : value['valuationRequestedAt'].toISOString(),
        'slug': value['slug'],
        'propertyId': value['propertyId'],
        'title': value['title'],
        'description': value['description'],
        'propertyCategory': value['propertyCategory'],
        'propertyType': value['propertyType'],
        'listingType': value['listingType'],
        'listingStatus': value['listingStatus'],
        'auctionStatus': value['auctionStatus'],
        'auctionStartDate': value['auctionStartDate'],
        'publishedAt': value['publishedAt'],
        'allowPrivateInspection': value['allowPrivateInspection'],
        'price': value['price'],
        'displayPrice': value['displayPrice'],
        'priceText': value['priceText'],
        'campaign': value['campaign'],
        'auctionStartPrice': value['auctionStartPrice'],
        'auctionNextPriceDropAt': value['auctionNextPriceDropAt'],
        'auctionScheduledEndAt': value['auctionScheduledEndAt'],
        'reverseAuctionDecreaseAmount': value['reverseAuctionDecreaseAmount'],
        'propertyAttributes': (0, PropertyAttributesDto_1.PropertyAttributesDtoToJSON)(value['propertyAttributes']),
        'propertyAmenities': (value['propertyAmenities'].map(PropertyAmenityDto_1.PropertyAmenityDtoToJSON)),
        'openInspections': value['openInspections'] == null ? undefined : (value['openInspections'].map(OpenInspectionDto_1.OpenInspectionDtoToJSON)),
        'activeOfferCount': value['activeOfferCount'],
        'activeBidCount': value['activeBidCount'],
        'enquiryCount': value['enquiryCount'],
        'inspectionCount': value['inspectionCount'],
        'highestBid': (0, BidDto_1.BidDtoToJSON)(value['highestBid']),
        'winningBid': (0, BidDto_1.BidDtoToJSON)(value['winningBid']),
        'saleHistory': (0, ListingDetailsSaleHistoryDto_1.ListingDetailsSaleHistoryDtoToJSON)(value['saleHistory']),
        'propertyOwners': value['propertyOwners'] == null ? undefined : (value['propertyOwners'].map(ListingDetailsUserDto_1.ListingDetailsUserDtoToJSON)),
        'propertyAgents': value['propertyAgents'] == null ? undefined : (value['propertyAgents'].map(ListingDetailsUserDto_1.ListingDetailsUserDtoToJSON)),
        'propertyMedia': (value['propertyMedia'].map(PropertyMediaItemDto_1.PropertyMediaItemDtoToJSON)),
        'propertyDocuments': (value['propertyDocuments'].map(PropertyDocumentDto_1.PropertyDocumentDtoToJSON)),
        'location': (0, LocationDto_1.LocationDtoToJSON)(value['location']),
        'isSeller': value['isSeller'],
        'offersAllowed': value['offersAllowed'],
        'enableAutoReply': value['enableAutoReply'],
        'lovableExtras': (0, LovableExtrasDto_1.LovableExtrasDtoToJSON)(value['lovableExtras']),
        'lovableExtrasAddedOn': value['lovableExtrasAddedOn'],
    };
}
